export default {
    bgColor: 'bg-transparent',
    className: 'px-1 rounded focus:outline-none focus:ring-2 focus:ring-white',
    iconClass: 'text-2xl',
    iconColor: 'text-indigo-200 hover:text-white ',
    iconType: 'close',
    isOnlyIcon: true,
    variant: 'ghost',
}
